import { render, staticRenderFns } from "./ReferralHistoryTable.vue?vue&type=template&id=750b01a2&scoped=true"
import script from "./ReferralHistoryTable.vue?vue&type=script&lang=js"
export * from "./ReferralHistoryTable.vue?vue&type=script&lang=js"
import style0 from "./ReferralHistoryTable.vue?vue&type=style&index=0&id=750b01a2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "750b01a2",
  null
  
)

export default component.exports